/**
 * Observation Facade
 *
 * Stable API surface for observation operations.
 * Aggregates actions for presentation layer consumption.
 * @agentic connections
 */

import type { MedplumClient } from "@medplum/core";
import type { Observation } from "@medplum/fhirtypes";
import {
  upsertObservation,
  type UpsertObservationInput,
} from "@benchmark/core/actions";

/**
 * Creates an Observation facade instance bound to a MedplumClient.
 * @agentic connections
 */
export function createObservationFacade(medplum: MedplumClient) {
  return {
    /**
     * Create or update an observation.
     * @agentic connections
     */
    upsert: (input: UpsertObservationInput): Promise<Observation> => {
      return upsertObservation(medplum, input);
    },
  };
}
